import { createSlice } from "@reduxjs/toolkit";
import {
  addBootCamps,
  addWebinarData,
  addWorkshopData,
  authSignin,
  cloneBootcamp,
  createNuterraData,
  createSpeakerImageData,
  createWorkshopSpeakerImageData,
  deleteBootcamp,
  deleteNuterra,
  deleteWebinar,
  deleteWorkshop,
  fetchAdminProfile,
  fetchCountriesCurrency,
  fetchAdminSubscriptions,
  fetchAllFreelancer,
  fetchAllHireTalent,
  fetchAdminDashboard,
  fetchBookingDetails,
  fetchBootcampDetails,
  fetchBootcamps,
  fetchCoachies,
  fetchNuterra,
  fetchOffers,
  fetchAdminTickets,
  fetchWorkNuterraBookings,
  getAllWebinarAdminData,
  getAllWorkshopAdminData,
  getWebinarAllData,
  toggleBootcampStatus,
  toggleNuterraStatus,
  toggleWorkShopStatus,
  updateAdminSubscription,
  updateBootcampImage,
  updateBootCamps,
  updateCoachStatus,
  updateNuterraData,
  updateSpeakerImageData,
  updateWebinarData,
  updateWorkshopData,
  updateWorkshopSpeakerImageData,
} from "../actions/authAction";

const initialState = {
  isLoading: false,
  tabs: [
    {
      label: "Webinar",
      value: "webinar",
    },
    {
      label: "Bootcamp",
      value: "bootcamp",
    },
    {
      label: "Bootcamp Booking",
      value: "booking_list",
    },
    {
      label: "Webinar List",
      value: "all_webinar",
    },
    {
      label: "Workshop",
      value: "work_shop",
    },
    {
      label: "Offers",
      value: "offer_list",
    },
    {
      label: "NuTerra",
      value: "nuterra_list",
    },
    {
      label: "NuTerra Booking",
      value: "nuterra_bookings",
    },
    {
      label: "Workshop Booking",
      value: "workshop_bookings",
    },
  ],
  userTabs: [
    {
      label: "Freelancers",
      value: "freelancers",
    },
    {
      label: "Coaches",
      value: "coaches",
    },
    {
      label: "Enterprises",
      value: "enterprises",
    },
  ],
  userTableHeaders: {
    freelancers: ["#", "Name", "Email", "Bio", "Talent Type", "Action"],
    coaches: ["#", "Name", "Phone Number", "Bio", "Status", "Actions"],
    enterprises: ["#", "Company Name", "Email", "Primary Contact", "Action",],
  },

  tableHeaders: {
    webinar: ["#", "Title", "Join Date", "Phone Number", "Role", "Actions"],

    bootcamp: [
      "#",
      "Title",
      "Description",
      "Created On",
      "Bootcamp Date",
      "Status",
      "Actions",
    ],
    booking_list: [
      "#",
      "User Name",
      "Email",
      "Bootcamp Name",
      "Start Date",
      "End Date",
      "Action",
    ],
    all_webinar: ["#", "Webinar Name", "Start Date", "Duration", "Action"],
    work_shop: ["#", "Workshop Name", "Start Date", "Duration", "Status", "Action"],
    nuterra_list: ["#", "NuTerra Name", "Start Date", "Duration", "Status", "Action"],
    nuterra_bookings: ["#", "Title", "Name", "Email", "Action"],
    workshop_bookings: ["#", "Title", "Name", "Email", "Action"],
    offer_list: [
      "#",
      "Offer Title",
      "Purpose",
      "Type",
      "Duration",
      "Format",
      "Price",
      "Action",
    ],
  },
  eventData: {},
  usersEventData: {},
  coachList: [],
  bootCampData: {},
  bookingData: [],
  allWebinarList: [],
  freelancerList: [],
  enterpriseList: [],
  adminTicketList: [],
  adminSubscriptionList: [],
  adminCountryCurrencyList: [],
  dashboardData: {},
};

const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  extraReducers: (builder) => {
    // auth-sign-in
    builder.addCase(authSignin.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(authSignin.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(authSignin.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetch-couches
    builder.addCase(fetchCoachies.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchCoachies.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.usersEventData = {
        ...state.usersEventData,
        coaches: data || [],
      };
      state.coachList = data || [];
      state.isLoading = false;
    });
    builder.addCase(fetchCoachies.rejected, (state, action) => {
      state.isLoading = false;
    });

    // updateCoachStatus
    builder.addCase(updateCoachStatus.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(updateCoachStatus.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(updateCoachStatus.rejected, (state, action) => {
      state.isLoading = false;
    });

    // getWebinarAllData
    builder.addCase(getWebinarAllData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getWebinarAllData.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.eventData = {
        ...state.eventData,
        webinar: data || [],
      };
      state.isLoading = false;
    });
    builder.addCase(getWebinarAllData.rejected, (state, action) => {
      state.isLoading = false;
    });
    // fetch-bootcamps
    builder.addCase(fetchBootcamps.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchBootcamps.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.eventData = {
        ...state.eventData,
        bootcamp: data || [],
      };
      state.isLoading = false;
    });
    builder.addCase(fetchBootcamps.rejected, (state, action) => {
      state.isLoading = false;
    });
    // fetch-bootcamps
    builder.addCase(fetchOffers.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchOffers.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.eventData = {
        ...state.eventData,
        offer_list: data || [],
      };
      state.isLoading = false;
    });
    builder.addCase(fetchOffers.rejected, (state, action) => {
      state.isLoading = false;
    });
    // fetch-nuterra
    builder.addCase(fetchNuterra.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchNuterra.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.eventData = {
        ...state.eventData,
        nuterra_list: data || [],
      };
      state.isLoading = false;
    });
    builder.addCase(fetchNuterra.rejected, (state, action) => {
      state.isLoading = false;
    });

    // addBootCamps
    builder.addCase(addBootCamps.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(addBootCamps.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(addBootCamps.rejected, (state, action) => {
      state.isLoading = false;
    });
    // toggle-bootcamp-status
    builder.addCase(toggleBootcampStatus.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(toggleBootcampStatus.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(toggleBootcampStatus.rejected, (state, action) => {
      state.isLoading = false;
    });
    // toggle-nuterra-status
    builder.addCase(toggleNuterraStatus.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(toggleNuterraStatus.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(toggleNuterraStatus.rejected, (state, action) => {
      state.isLoading = false;
    });
    // toggle-workshop-status
    builder.addCase(toggleWorkShopStatus.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(toggleWorkShopStatus.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(toggleWorkShopStatus.rejected, (state, action) => {
      state.isLoading = false;
    });

    // delete-bootcamps
    builder.addCase(deleteBootcamp.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(deleteBootcamp.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(deleteBootcamp.rejected, (state, action) => {
      state.isLoading = false;
    });
    // clone-bootcamp
    builder.addCase(cloneBootcamp.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(cloneBootcamp.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(cloneBootcamp.rejected, (state, action) => {
      state.isLoading = false;
    });
    // update-bootcamp-images
    builder.addCase(updateBootcampImage.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(updateBootcampImage.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(updateBootcampImage.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetch-bootcamp-detail
    builder.addCase(fetchBootcampDetails.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchBootcampDetails.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.bootCampData = data || {};
      state.isLoading = false;
    });
    builder.addCase(fetchBootcampDetails.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetchBookingDetails
    builder.addCase(fetchBookingDetails.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchBookingDetails.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.eventData = {
        ...state.eventData,
        booking_list: data || [],
      };
      state.bookingData = data || [];
      state.isLoading = false;
    });
    builder.addCase(fetchBookingDetails.rejected, (state, action) => {
      state.isLoading = false;
    });

    // addWebinarData
    builder.addCase(addWebinarData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(addWebinarData.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(addWebinarData.rejected, (state, action) => {
      state.isLoading = false;
    });

    // createSpeakerImageData
    builder.addCase(createSpeakerImageData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(createSpeakerImageData.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(createSpeakerImageData.rejected, (state, action) => {
      state.isLoading = false;
    });

    // getAllWebinarAdminData
    builder.addCase(getAllWebinarAdminData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getAllWebinarAdminData.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.eventData = {
        ...state.eventData,
        all_webinar: data || [],
      };
      state.allWebinarList = data ?? [];
      state.isLoading = false;
    });
    builder.addCase(getAllWebinarAdminData.rejected, (state, action) => {
      state.isLoading = false;
    });

    // deleteWebinar
    builder.addCase(deleteWebinar.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(deleteWebinar.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(deleteWebinar.rejected, (state, action) => {
      state.isLoading = false;
    });

    // updateWebinarData
    builder.addCase(updateWebinarData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(updateWebinarData.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(updateWebinarData.rejected, (state, action) => {
      state.isLoading = false;
    });

    // updateSpeakerImageData
    builder.addCase(updateSpeakerImageData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(updateSpeakerImageData.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(updateSpeakerImageData.rejected, (state, action) => {
      state.isLoading = false;
    });

    // addWorkshopData
    builder.addCase(addWorkshopData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(addWorkshopData.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(addWorkshopData.rejected, (state, action) => {
      state.isLoading = false;
    });

    // createWorkshopSpeakerImageData
    builder.addCase(createWorkshopSpeakerImageData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(
      createWorkshopSpeakerImageData.fulfilled,
      (state, action) => {
        state.isLoading = false;
      }
    );
    builder.addCase(
      createWorkshopSpeakerImageData.rejected,
      (state, action) => {
        state.isLoading = false;
      }
    );

    // getAllWorkshopAdminData
    builder.addCase(getAllWorkshopAdminData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getAllWorkshopAdminData.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.eventData = {
        ...state.eventData,
        work_shop: data || [],
      };
      state.isLoading = false;
    });
    builder.addCase(getAllWorkshopAdminData.rejected, (state, action) => {
      state.isLoading = false;
    });
    // fetchWorkNuterraBookings
    builder.addCase(fetchWorkNuterraBookings.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchWorkNuterraBookings.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      const { type } = action.meta.arg || {};
      if (type === "nuterra") {
        state.eventData = {
          ...state.eventData,
          nuterra_bookings: data || [],
        };
      }

      if (type === "workshop") {
        state.eventData = {
          ...state.eventData,
          workshop_bookings: data || [],
        };
      }
      state.isLoading = false;
    });
    builder.addCase(fetchWorkNuterraBookings.rejected, (state, action) => {
      state.isLoading = false;
    });

    // deleteWorkshop
    builder.addCase(deleteWorkshop.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(deleteWorkshop.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(deleteWorkshop.rejected, (state, action) => {
      state.isLoading = false;
    });

    // updateWorkshopSpeakerImageData
    builder.addCase(updateWorkshopSpeakerImageData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(
      updateWorkshopSpeakerImageData.fulfilled,
      (state, action) => {
        state.isLoading = false;
      }
    );
    builder.addCase(
      updateWorkshopSpeakerImageData.rejected,
      (state, action) => {
        state.isLoading = false;
      }
    );

    // updateWorkshopData
    builder.addCase(updateWorkshopData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(updateWorkshopData.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(updateWorkshopData.rejected, (state, action) => {
      state.isLoading = false;
    });

    // updateBootCamps
    builder.addCase(updateBootCamps.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(updateBootCamps.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(updateBootCamps.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetchAllFreelancer
    builder.addCase(fetchAllFreelancer.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchAllFreelancer.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.usersEventData = {
        ...state.usersEventData,
        freelancers: data || [],
      };
      state.freelancerList = data || [];
      state.isLoading = false;
    });
    builder.addCase(fetchAllFreelancer.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetchAllHireTalent
    builder.addCase(fetchAllHireTalent.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchAllHireTalent.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.usersEventData = {
        ...state.usersEventData,
        enterprises: data || [],
      };
      state.enterpriseList = data || [];
      state.isLoading = false;
    });
    builder.addCase(fetchAllHireTalent.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetchAdminTickets
    builder.addCase(fetchAdminTickets.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchAdminTickets.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.adminTicketList = data || [];
      state.isLoading = false;
    });
    builder.addCase(fetchAdminTickets.rejected, (state) => {
      state.isLoading = false;
    });

    // fetchAdminSubscriptions
    builder.addCase(fetchAdminSubscriptions.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchAdminSubscriptions.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.adminSubscriptionList = data || [];
      state.isLoading = false;
    });
    builder.addCase(fetchAdminSubscriptions.rejected, (state) => {
      state.isLoading = false;
    });

    // fetchCountriesCurrency
    builder.addCase(fetchCountriesCurrency.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchCountriesCurrency.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.adminCountryCurrencyList = data || [];
      state.isLoading = false;
    });
    builder.addCase(fetchCountriesCurrency.rejected, (state) => {
      state.isLoading = false;
    });

    // updateAdminSubscription
    builder.addCase(updateAdminSubscription.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(updateAdminSubscription.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(updateAdminSubscription.rejected, (state) => {
      state.isLoading = false;
    });

    // create-nuterra-data
    builder.addCase(createNuterraData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(createNuterraData.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(createNuterraData.rejected, (state, action) => {
      state.isLoading = false;
    });
    // update-nuterra-data
    builder.addCase(updateNuterraData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(updateNuterraData.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(updateNuterraData.rejected, (state, action) => {
      state.isLoading = false;
    });
    // delete-nuterra
    builder.addCase(deleteNuterra.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(deleteNuterra.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(deleteNuterra.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetchAdminProfile
    builder.addCase(fetchAdminProfile.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchAdminProfile.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(fetchAdminProfile.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetch-admin-dashboard
    builder.addCase(fetchAdminDashboard.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchAdminDashboard.fulfilled, (state, action) => {
      const { data } = action.payload || {};
      state.dashboardData = data || {};
      state.isLoading = false;
    });
    builder.addCase(fetchAdminDashboard.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default authSlice.reducer;
